import { render, staticRenderFns } from "./TaskSet.vue?vue&type=template&id=8f560a7a&scoped=true&"
import script from "./TaskSet.vue?vue&type=script&lang=js&"
export * from "./TaskSet.vue?vue&type=script&lang=js&"
import style0 from "./TaskSet.vue?vue&type=style&index=0&id=8f560a7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f560a7a",
  null
  
)

export default component.exports